import { useStacklineTheme } from '@stackline/ui';
import React, { InputHTMLAttributes } from 'react';
import { numberMask } from 'src/components/BeaconV2Components/common/StyledInput/inputMasks';
import MaskedInput from 'src/components/BeaconV2Components/common/StyledInput/MaskedInput';
import numeral from 'numeral';
import { styled } from '@mui/material';

export const EditInput = ({
  prefix,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & {
  prefix?: string;
}): JSX.Element => {
  const theme = useStacklineTheme();
  const placeholder = props?.placeholder ? numeral(props?.placeholder).format('1,000.00') : '';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        borderBottom: `0.5px solid ${theme.colors.primaryGray}`
      }}
    >
      {prefix && <div style={{ color: theme.colors.primary, fontSize: '14px', fontWeight: '400' }}>{prefix}</div>}
      <MaskedInput
        masker={numberMask}
        value={props?.value}
        onChange={props?.onChange}
        placeholder={placeholder}
        style={{ height: 24, border: 'none', fontSize: 14, paddingLeft: 4 }}
        autoComplete="off"
        id="type-search"
        onFocus={props?.onFocus}
        onBlur={props?.onBlur}
        disabled={props?.disabled}
      />
    </div>
  );
};

export const ButtonGroup = styled('div')({
  height: 18,
  width: 0,
  opacity: 0,
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: 4,
  transition: 'all 0.3s ease-in',
  '&.focus': {
    overflow: 'hidden',
    width: 48,
    opacity: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: 4
  }
});
